module.exports = "https://cdn.realtymogul.com/static/media/carousel-arrow-large-left.302a2246.svg";